import { SET_SUMMARY_ATTOP } from "redux/types";

const showSummaryAtTop = (payload) => {
    return { type: SET_SUMMARY_ATTOP, payload };
};

export { showSummaryAtTop };
